import pluginRegistry from "~/components/Actions/pluginRegistry";
import getApplyChangesetRegistration from "./awsApplyCloudFormationAction";
import getChangesetsFeature from "./awsCloudFormationChangesetFeature";
import getDeleteCloudFormationRegistration from "./awsDeleteCloudFormationAction";
import getDeployCloudFormationRegistration from "./awsDeployCloudFormationAction";
import getAwsRunScriptRegistration from "./awsRunScriptAction";
import getUploadS3Registration from "./awsUploadS3Action";

pluginRegistry.registerAction(getAwsRunScriptRegistration());
pluginRegistry.registerAction(getDeleteCloudFormationRegistration());
pluginRegistry.registerAction(getDeployCloudFormationRegistration());
pluginRegistry.registerAction(getUploadS3Registration());
pluginRegistry.registerAction(getApplyChangesetRegistration());

pluginRegistry.registerFeature(getChangesetsFeature());
